import type { CSSProperties, ImgHTMLAttributes, ReactNode } from 'react';

type Props = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  fill?: boolean;
  priority?: boolean;
  unoptimized?: boolean;
  loader?: unknown;
  quality?: number;
  placeholder?: string;
  blurDataURL?: string;
  sizes?: string;
  children?: ReactNode;
};

/** Vite SPA 对 `next/image` 的轻量 shim（普通 img）。 */
export default function Image({
  src,
  alt,
  width,
  height,
  fill,
  priority: _priority,
  unoptimized: _unoptimized,
  loader: _loader,
  quality: _quality,
  placeholder: _placeholder,
  blurDataURL: _blur,
  sizes: _sizes,
  style,
  ...rest
}: Props) {
  const fillStyle: CSSProperties | undefined = fill
    ? {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        ...style,
      }
    : style;

  return (
    <img
      src={src}
      alt={alt}
      width={fill ? undefined : width}
      height={fill ? undefined : height}
      style={fillStyle}
      {...rest}
    />
  );
}
